import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';
import { approvalIconRegistry } from '../../types/iconRegistry';

function ApprovalCard({ approval, selected, onSelect, onAction }) {
  const ApprovalIcon = approvalIconRegistry[approval.icon] || FiIcons.FiAlertTriangle;

  return (
    <motion.article
      layout
      className={`approval-card ${selected ? 'selected' : ''}`}
      onClick={() => onSelect(approval.id)}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="approval-icon">
        <ApprovalIcon />
      </div>
      <div className="approval-content">
        <div className="approval-meta">
          <span>{approval.agent}</span>
          <em className={`risk-${approval.risk}`}>{approval.risk} risk</em>
          <time>{approval.time}</time>
        </div>
        <h3>{approval.title}</h3>
        <p>{approval.description}</p>
        <div className="approval-impact">
          <FiIcons.FiActivity />
          {approval.impact}
        </div>
      </div>
      <div className="approval-actions">
        <button className="approve" onClick={(event) => onAction(event, approval.id, 'approved')} type="button">
          <FiIcons.FiCheck /><span>Approve</span><kbd>A</kbd>
        </button>
        <button className="modify" onClick={(event) => onAction(event, approval.id, 'modified')} type="button">
          <FiIcons.FiEdit2 /><span>Modify</span><kbd>M</kbd>
        </button>
        <button className="reject" onClick={(event) => onAction(event, approval.id, 'rejected')} type="button">
          <FiIcons.FiX /><span>Reject</span><kbd>R</kbd>
        </button>
      </div>
    </motion.article>
  );
}

export default ApprovalCard;